import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { alertRef } from '../../App';
import Modal from '../../Components/Modal/Modal';
import StatusBadge from '../../Components/StatusBadge/StatusBadge';
import { Button, Input } from '../../Components/StyledComponents';
import Table from '../../Components/Table/Table';
import { convertCost } from '../../Utils/functions';
import './Index.scss'

const statusList = {
  Pending : '보유중',
  Done : '사용완료',
  Canceled : '결제취소'
}

const variant = {
  Pending : 'primary',
  Done : 'normal',
  Canceled : 'danger'
}

const CommerceHistory = () => {
    const modalRef = React.useRef(null);
    const [ data, setData ] = React.useState({});
    const [ password , setPassword ] = React.useState('')
    
    const columnsCoupon = React.useMemo(
        () => [
          {
            Header: '쿠폰 이름',
            accessor: 'DisplayName', // accessor is the "key" in the data
            disableSortBy : true,
            Cell : (props) => {
              return (
                <p className='table-title'>{props.cell.value}</p>
              )
            },
            width : 220,
            minWidth : 220
          },
          {
            Header: '쿠폰 설명',
            accessor: 'Description',
            disableSortBy : true,
            minWidth : 220,
            width : 220,
            Cell : (props) => {
                return(
                    <p>{props.cell.value}</p>
                )
            }
          },
          {
            Header: '쿠폰가격',
            accessor: 'Price', // accessor is the "key" in the data
            disableFilters : true,
            Cell : (props) => {
              return (
                <p>{convertCost(props.cell.value)}원</p>
              )
            },
            width : 100,
            minWidth : 100
          },
          {
            Header: '결제일시',
            accessor: 'OrderDate.$date',
            disableFilters : true,
            minWidth : 140,
            width : 140,
            Cell : (props) => {
              return(
                  <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm')}</p>
              )
            }
          },
          {
            Header: '유저번호',
            accessor: 'UserInfo',
            disableSortBy : true,
            minWidth : 140,
            width : 140,
            Cell : (props) => {
              if(typeof props.cell.value !== 'undefined'){
                return(
                  <Link to={ `/user-info/${props.cell.value._id.$oid}`}>
                    <p style={{ color : '#f95f53' }}>{ (typeof props.cell.value === 'undefined') ? '탈퇴한 회원' : props.cell.value.Tel}</p>
                  </Link>
                )
              }else {
                return(
                  <p style={{ color : '#f95f53' }}>{ (typeof props.cell.value === 'undefined') ? '탈퇴한 회원' : props.cell.value.Tel}</p>
                )
              }
            }
          },
          {
            Header: '상태',
            accessor: 'Status',
            disableFilters : true,
            isDropdown : true,
            options : [
              { key : 'test1' , value : 'Ccc11'},
              { key : 'test2' , value : '22'},
              { key : 'test3' , value : '33'},
              { key : 'test4' , value : '44'},
            ],
            Cell : (props) => {
                if(props.cell.value === 'Pending'){
                  return (
                    <Button
                      variant={'main'}
                      style={{ width : 86, height : 38, padding: 0 }}
                      onClick={() => {setPassword('');modalRef.current.openModal();}}>
                      사용하기
                    </Button>
                  )
                }else{
                  return(
                      <StatusBadge Status={statusList[props.cell.value]} variant={variant[props.cell.value]}/>
                  )
                }
            },
            minWidth : 100,
            width : 100
          },
        ]
    )

    return (
        <div>
            <Table columns={columnsCoupon} url={'/api/history/commerce'}/>
            <Modal ref={modalRef} contentContainer={{ width : 472 }} isHeader title={'비밀번호 입력하기'} onBackdropClick={() => modalRef.current.closeModal()}>
              <p className='input-label'>비밀번호 입력</p>
              <Input
                type='password'
                style={{ width : '100%' }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder='사용처리를 위해 비밀번호를 입력해주세요.'
                />
                <Button
                  variant={'main'}
                  style={{ width : 120, alignSelf : 'flex-end', marginTop : 32 }}
                  onClick={() => 
                    { modalRef.current.closeModal();
                      if(password === '1351@!'){
                      alertRef.current.showAlert({ title : `쿠폰이 사용되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => {alertRef.current.hideAlert()} })
                    }}
                  }>
                  사용하기
                </Button>
            </Modal>
        </div>
    )
}

export default CommerceHistory;